import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { ProjectsView } from "../features/memory/index.ts";

export const MemoryProjects: FC = () => (
  <PageContainer>
    <ProjectsView />
  </PageContainer>
);
